import { DateTimeFilter, OptionFilter, StringFilter } from '@common/searchFilter/searchFilter.models';
import { IProjectMasterScheduleOption } from '@masterSchedule/masterSchedule.models';

export enum EDesignBriefDetailSearchParamKey {
  masterScheduleId = 'masterScheduleId',
}

export interface IDesignBriefSearchFilter {
  designBriefNo: StringFilter;
  t1RefNo: StringFilter;
  designPackage: StringFilter;
  description: StringFilter;
  riskCategory: OptionFilter;
  actioner: OptionFilter;
  requiredDate: DateTimeFilter;
  srp: OptionFilter;
  twc: OptionFilter;
  designer: OptionFilter;
}

export interface IDesignBriefSearch {
  id: number;
  projectId: number;
  designBriefNo?: string;
  riskCat?: string;
  status?: string;
  projectMasterSchedule: IProjectMasterScheduleOption;
  actioner?: string;
  designer?: string;
  srp?: string;
  twc?: string;
}

export enum EDesignBriefSearchKey {
  designBriefNo = 'designBriefNo',
  description = 'briefDescription',
  actioner = 'actioner',
  riskCategory = 'riskCategory',
  t1RefNo = 't1RefNo',
  designPackage = 'designPackage',
  designer = 'designer',
  twc = 'twc',
  srp = 'srp',
}

export enum EDesignBriefSearchColumnKeys {
  t1RefNo = 'projectMasterSchedule.refNo',
  description = 'briefDescription',
  designBriefNo = 'designBriefNo',
  designPackage = 'projectMasterSchedule.designPackage',
  twc = 'twc',
  srp = 'srp',
  designer = 'designer',
  actioner = 'actioner',
  riskCategory = 'projectMasterSchedule.riskCategory',
}
